
import React, { useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { fetchdata } from '../reduxactions/adminrsactions/AdFundmanActions';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { GFNButton } from '../ui/GFNButton';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { useNavigate } from 'react-router-dom';

export const AdminFundmanager = () => {

  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('');

  const data = useSelector((state: RootState) => state.adfundmanagerlist.data);


  const dispatch = useDispatch()

  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  // To get data
  useEffectOnce(() => {
    fetchDataAsync();
  }, [dispatch]);

  const navigate = useNavigate();
  //To open view
  const handleButtonClick = (rowData: any) => {
    const url = `/viewfundmanager/${rowData.fundman_id}`;
    console.log('Row ID:', rowData.id);

    // Use navigate to navigate to the URL
    navigate(url);
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/adminfundmanager.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            {/* <section className="content-header">
              <div className="container-fluid">
                <div className="grid mb-2">
                  <div className="col-9">
                    <h1>Fund Managers</h1>
                  </div>
                  <div className="col-3">
                    <a
                      title="help"
                      onClick={(e) => openWindow(e, IUrl)}
                      style={{

                        color: "blue",
                        fontSize: 15, cursor: "pointer"
                      }}
                    >Help for this Page &nbsp;
                      <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                    </a>
                  </div>

                </div>
              </div>
            </section> */}
            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">Fund Managers</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
            {/* <section className="content"> */}
            <div className="grid">
              <div className="col-12">
                <div className="card card-primary">
                  {/* <Card title=""> */}
                  <Panel header="">
                    <div className="card card-primary">
                      <div className="card flex flex-wrap justify-content-end my-2">
                        <span className="p-input-icon-left">
                          <i className="pi pi-search ml-2" />

                          <InputText
                            className="app-search-input"
                            value={globalFilter}
                            onChange={(e) => setGlobalFilter(e.target.value)}
                            placeholder="Global Search"
                          />
                        </span>
                      </div>
                      <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                        <Column field="name" sortable header="Name"></Column>
                        <Column field="email" sortable header="Email"></Column>
                        <Column field="CountryName" sortable header="Country"></Column>
                        <Column field="status" sortable header="Status"></Column>
                        <Column header="Operation" body={(rowData, { rowIndex }) => (
                          <>
                            <GFNButton icon="pi pi-eye" buttonType="primary" size="sm" tooltip="View" testId={`view-btn${rowIndex}`} onClick={() => handleButtonClick(rowData)} />
                          </>
                        )} />
                      </DataTable>
                    </div>
                  </Panel>
                  {/* </Card> */}
                </div>
              </div>
            </div>
            {/* </section> */}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AdminFundmanager

